import type { ReactNode } from 'react';
// @ts-ignore
import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { RentalManagerEnvironmentProvider } from '../components';
import type { InitializeBrowserOptions } from './browserEnv';
import { initializeBrowser, initializeNodelessBrowser } from './browserEnv';
import type { SplitExperimentsProps } from '@zg-rentals/split';
import { SplitProvider } from '@zg-rentals/split';
import type { RentalManagerEnvironment } from '@zg-rentals/rental-manager-env-base';
import { RpErrorBoundary } from '@zg-rentals/rp-bootstrap-browser';

const generateBaseExperiments = (environment: RentalManagerEnvironment) => {
  const splitInitialState: SplitExperimentsProps = {};
  if (environment.experiments) {
    for (const key in environment.experiments) {
      splitInitialState[key] = {
        featureName: key,
        treatment: environment.experiments[key],
      };
    }
  }
  return splitInitialState;
};

export const renderClientIndex = ({
  app,
  appName,
  onBootstrapRegister,
}: InitializeBrowserOptions & { app: ReactNode }) => {
  const container = document.getElementById('app-root');
  if (__STATIC_APP__) {
    const root = createRoot(container!);
    const environment = initializeNodelessBrowser({
      appName,
      zgApi: __API__!,
      isProduction: __PROD__,
      buildNumber: __BUILD_NUMBER__,
      onBootstrapRegister,
    });

    const splitInitialState = generateBaseExperiments(environment);

    root.render(
      <RpErrorBoundary>
        <SplitProvider experiments={splitInitialState}>
          <RentalManagerEnvironmentProvider environment={environment}>
            <BrowserRouter>{app}</BrowserRouter>
          </RentalManagerEnvironmentProvider>
        </SplitProvider>
      </RpErrorBoundary>,
    );
  } else {
    const environment = initializeBrowser({
      appName,
      onBootstrapRegister,
    });

    const splitInitialState = generateBaseExperiments(environment);

    hydrateRoot(
      container!,
      <RpErrorBoundary>
        <SplitProvider experiments={splitInitialState}>
          <RentalManagerEnvironmentProvider environment={environment}>
            <BrowserRouter>{app}</BrowserRouter>
          </RentalManagerEnvironmentProvider>
        </SplitProvider>
      </RpErrorBoundary>,
    );
  }
};
